














































































































































































































import {
  Component,
  Vue
} from "vue-property-decorator";
import PopUpButton from "@/components/PopUpButton.vue";
@Component({
  components: {
    PopUpButton
  }
})
export default class AbbrevsPopUp extends Vue {
  showAbbrevs() {
    (this.$refs.abbrevpop as PopUpButton).showPopUp();
  }
}
